'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Empty;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */
function Empty(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color;

  return _react2.default.createElement(
    'svg',
    {
      focusable: 'false',
      'aria-hidden': true,
      className: 'icon-svg-dots-empty ' + className,
      width: width,
      height: height,
      viewBox: '0 0 16 16' },
    _react2.default.createElement('circle', {
      cx: '8',
      cy: '8',
      r: '5.5',
      stroke: color,
      strokeWidth: '1',
      fill: 'none',
      fillRule: 'evenodd' })
  );
}

Empty.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Dots/Empty.js
// module id = 210
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16